import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';
import { IdexFromComponent } from '../idex-scheme-list/idex-from/idex-from.component';
import { OcProposalUploadComponent } from '../idex-scheme-list/oc-proposal-upload/oc-proposal-upload.component';
import { TdfFromComponent } from '../tdf-scheme-list/tdf-from';
import { getTprFromTemplate } from '../../pre-ready-tepmlate';

@Component({
  selector: 'app-idex',
  standalone: false,
  templateUrl: './idex.component.html',
  styleUrl: './idex.component.scss',
})
export class IdexComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(IdexFromComponent) idexFromComponent?: IdexFromComponent;
  @ViewChild(OcProposalUploadComponent) ocProposalUploadComponent?: OcProposalUploadComponent;
  @ViewChild(TdfFromComponent) tdfFromComponent?: TdfFromComponent;
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() type: string ;
  @Input() isViewOnly: boolean;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() screening: string = '';
  @Input() url: string ;
  
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  uploadedFiles: any[] = [];
  apiUrl = environment.APIUrl;
  payload: any;
  @Input() id: any;
  PDSGenId: any;
  needGenData: any;
  needGenId;
  selectedDraftProposal: any;
  private subscriptions = new Subscription();
  userID: any;

  userList: any;
  userListCopy: any[];  
  unitList: any;
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnInit(): void {
 
   
    // this.proposalForm = this.fb.group({
    //   technologyInsertion: ['', Validators.required],
    //   // justificationText: ['', Validators.required],
    //   // exportPotential: ['', Validators.required],
    //   // objective: ['', Validators.required],
    //   justificationText: [''],
    //   exportPotential: [''],
    //   objective: [''],
    //   existing_system: [''],
    //   functionalRequirements: [''],
    //   contemporarySolutions: [''],
    //   miscellaneousInfo: [''],
    //   references: [''],
    //   keywords: [''],
    //   estimatedRequirement: [''],
    //   testingMethodology: [''],
    //   civilSpinOffs: [''],
    //   technologyReadinessLevel: [''],
    //   proposalExplanation: [''],
    //   qaAgency: [''],
    //   apsoConcurrence: [''],
    //   psqr: [''],
    //   additionalInformation: [''],
    //   qtyRequired: [''],
    //   // Additional form controls for Description Of The Item section
    //   description: [''],
    //   item_desription: [''],
    //   existingSystemDetails: [''],
    //   importIndigenisation: [''],
    //   import_indigenisation: [''],
    //   costPresentSystem: [''],
    //   cost_system: [''],
    //   deficiencyExistingSystem: [''],
    //   deficiency_system: [''],
    //   deficiencyPlugged: [''],
    //   deficiency_plugged: [''],
    //   proposedSystem: [''],
    //   proposed_system: [''],
    //   whoWillUse: [''],
    //   use_system: [''],
    //   problemStatement: [''],
    //   problem_solve: [''],
    //   // Additional form controls for Functional and Operational requirements section
    //   functionalParameters: [''],
    //   operational_requirement: [''],
    //   functional_parameters: [''],
    //   environmentalRequirements: [''],
    //   environmental_requirements: [''],
    //   usability: [''],
    //   physicalConstraints: [''],
    //   physical_constraints: [''],
    //   reliability: [''],
    //   reliability_maintainability: [''],
    //   anyOther: [''],
    //   any_other: [''],
    // });

    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
      if(['tdf_tpr'].includes(this.stepDetails.code)) {
        this.getChallenge();
      } 
    });

  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.proposalForm?.enable();
      } else {
        this.isEditorDisabled = true;
        this.proposalForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }


    expandedSections = {
    nodalAgency: true,
    basicInfo: false,
    problemStatement: false,
    detailedInfo: false,
    additionalInfo: false,
    uploads: false
  };
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.editorReady = true; // recreate editor
    }, 0);
  }
 
  goToNextStep() {
    this.stepCompleted.emit();
  }

  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  generatePDF() {
    let payload;
    if (this.schemeType == 'tdf') {
      payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload?.proposal_name },
          {
            key: 'Title of the Requirement',
            value: this.proposalForm.get('technologyInsertion')?.value,
          },
          {
            key: 'Description of major system/sub-system and usage',
            value: this.proposalForm.get('justificationText')?.value,
          },
          {
            key: 'Reason for pursuing under TDF scheme',
            value: this.proposalForm.get('exportPotential')?.value,
          },
          {
            key: 'Technology Area (Discipline, Sub-discipline)',
            value: this.proposalForm.get('stakeholderDiscussions')?.value,
          },
          {
            key: 'Objective (Product/System/Item)',
            value: this.proposalForm.get('objective')?.value,
          },
          {
            key: 'Existing System Description & Use',
            value: this.proposalForm.get('existingSystem')?.value,
          },
          {
            key: 'Functional & Operational Requirements',
            value: this.proposalForm.get('functionalRequirements')?.value,
          },
          {
            key: 'Contemporary Solutions (National/International)',
            value: this.proposalForm.get('contemporarySolutions')?.value,
          },
          {
            key: 'Miscellaneous Information',
            value: this.proposalForm.get('miscellaneousInfo')?.value,
          },
          {
            key: 'References',
            value: this.proposalForm.get('references')?.value,
          },
          { key: 'Keywords', value: this.proposalForm.get('keywords')?.value },
          {
            key: 'Estimated Navy Requirement (3-5 yrs)',
            value: this.proposalForm.get('estimatedRequirement')?.value,
          },
          {
            key: 'Testing Methodology, Criteria, Venue',
            value: this.proposalForm.get('testingMethodology')?.value,
          },
          {
            key: 'Likely Civil Spin Offs',
            value: this.proposalForm.get('civilSpinOffs')?.value,
          },
          {
            key: 'Technology Readiness Level (TRL)',
            value: this.proposalForm.get('technologyReadinessLevel')?.value,
          },
          {
            key: 'Proposal Category (Substitution/Upgrade/etc.)',
            value: this.proposalForm.get('proposalExplanation')?.value,
          },
          { key: 'QA Agency', value: this.proposalForm.get('qaAgency')?.value },
          {
            key: 'Concurrence by APSO',
            value: this.proposalForm.get('apsoConcurrence')?.value,
          },
          {
            key: 'PSQR',
            value: this.proposalForm.get('psqr')?.value,
          },
          {
            key: 'Additional Information',
            value: this.proposalForm.get('additionalInformation')?.value,
          },
          {
            key: 'Quantity Required',
            value: this.proposalForm.get('qtyRequired')?.value,
          },
          // Description Of The Item section
          {
            key: 'Description of Item',
            value: this.proposalForm.get('description')?.value,
          },
          {
            key: 'Details of existing system and its use',
            value: this.proposalForm.get('existing_system')?.value,
          },
          {
            key: 'Whether import/ available through indigenisation?',
            value: this.proposalForm.get('importIndigenisation')?.value,
          },
          {
            key: 'Cost of Present System',
            value: this.proposalForm.get('costPresentSystem')?.value,
          },
          {
            key: 'Deficiency in the existing system',
            value: this.proposalForm.get('deficiencyExistingSystem')?.value,
          },
          {
            key: 'How deficiency plugged presently?',
            value: this.proposalForm.get('deficiencyPlugged')?.value,
          },
          {
            key: 'What will have proposed system do?',
            value: this.proposalForm.get('proposedSystem')?.value,
          },
          {
            key: 'Who will use the system and how?',
            value: this.proposalForm.get('whoWillUse')?.value,
          },
          {
            key: 'What problem will this to solve?',
            value: this.proposalForm.get('problemStatement')?.value,
          },
          // Functional and Operational requirements section
          {
            key: 'Functional Parameters',
            value: this.proposalForm.get('functionalParameters')?.value,
          },
          {
            key: 'Environmental requirements',
            value: this.proposalForm.get('environmentalRequirements')?.value,
          },
          {
            key: 'Usability',
            value: this.proposalForm.get('usability')?.value,
          },
          {
            key: 'Physical Constraints',
            value: this.proposalForm.get('physicalConstraints')?.value,
          },
          {
            key: 'Reliability and maintainability',
            value: this.proposalForm.get('reliability')?.value,
          },
          {
            key: 'Any Other',
            value: this.proposalForm.get('anyOther')?.value,
          },
        ],
      };
    }
    this.generatePDFEmitter.emit(payload);
  }

  submitOcProposal(): void {
    this.ocProposalUploadComponent?.stepSubmit();
  }
  onSubmit() {
    if(this.stepDetails.code == 'tdf_tpr' && this.schemeType == 'tdf'){
      this.tprSubmit();
      return;
    }
    if (this.schemeType == 'tdf' && this.stepDetails.code != 'tdf_tpr') {
      this.tdfFromComponent?.stepSaveApiCall();
      return;
    }
    this.idexFromComponent?.stepSaveApiCall();
  }

  getChallenge() {
    this.apiService.getAPI(`${this.url}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
      this.needGenData = res[0];
      this.tprData = this.needGenData?.user_lab_armed_forces ? this.needGenData?.user_lab_armed_forces : getTprFromTemplate(this.payload?.proposal_name);
    });
   }

;


  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
tprData : any;
 tprSubmit() {
    let payload={
      proposal_step: this.stepDetails.id,
      user_lab_armed_forces: this.tprData,
    }
    if(this.needGenData?.id){
      this.apiService.putAPI(this.url+this.needGenData?.id+'/',payload).subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'TPR updated successfully'
        });
        this.getChallenge();
      });
    }else{
      this.apiService.postAPI(this.url,payload).subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'TPR submitted successfully'
        });
        this.getChallenge();
      });
    }
  }


  getValuationFieldVisible(step) {
    if(step.code == 'IPV') {
      return {
      name: false,
      scheme: false,
      organisation: false,
      category: false,
      challenge_brief: false,
      prototype_development: false,
      release_date: false,
      nodal_officer_id: false,
      nodal_precurement: false,
      technology_domain: false,
      problem_statement: false,
      coordinated_agency_id: false,
      requirement: false,
      ip_value: true,
      functional_advantages: false,
      domestic: false,
      substitution: false,
      preliminary_scope: false,
      competitive_solution: false,
      potential_market: false,
      risk_assessment: false,
      mpo_qty: false,
      proposal_id: false,
      }
    }else{
    return {
      name: true,
      scheme: true,
      organisation: true,
      category: true,
      challenge_brief: true,
      prototype_development: true,
      release_date: true,
      nodal_officer_id: true,
      nodal_precurement: true,
      technology_domain: true,
      problem_statement: true,
      coordinated_agency_id: true,
      requirement: true,
      ip_value: true,
      functional_advantages: true,
      domestic: true,
      substitution: true,
      preliminary_scope: true,
      competitive_solution: true,
      potential_market: true,
      risk_assessment: true,
      mpo_qty: true,
      proposal_id: true,
    }
  }
  }

}
